export const bathrobes = [
  { id: 1, name: "Classic White Robe", price: 89, color: "#f5f0eb", borderColor: "#c9a96e", badge: "Bestseller" },
  { id: 2, name: "Grey Elegance Robe", price: 89, color: "#9e9e9e", borderColor: "#c9a96e" },
  { id: 3, name: "Navy Blue Robe", price: 89, color: "#1a2744", borderColor: "#c9a96e", badge: "New" },
  { id: 4, name: "Burgundy Robe", price: 89, color: "#6b1a2a", borderColor: "#c9a96e" },
  { id: 5, name: "Beige Comfort Robe", price: 89, color: "#c5aa85", borderColor: "#c9a96e" },
  { id: 6, name: "Blush Pink Robe", price: 89, color: "#d4a5a0", borderColor: "#c9a96e", badge: "New" },
  { id: 7, name: "Olive Green Robe", price: 89, color: "#6b7a5e", borderColor: "#c9a96e" },
  { id: 8, name: "Charcoal Robe", price: 89, color: "#4a4a4a", borderColor: "#c9a96e" },
];

export const towels = [
  { id: 9, name: "Ivory Bath Towel", price: 45, color: "#f5f0e8", borderColor: "#c9a96e", badge: "Bestseller" },
  { id: 10, name: "Sand Dune Towel", price: 45, color: "#c4a882", borderColor: "#c9a96e" },
  { id: 11, name: "Stone Grey Towel", price: 45, color: "#8c8c8c", borderColor: "#c9a96e" },
  { id: 12, name: "Slate Blue Towel", price: 45, color: "#5a7a8a", borderColor: "#c9a96e", badge: "New" },
];

export const babyCollection = [
  { id: 13, name: "Baby Hooded Towel", price: 35, color: "#f5e6c8", borderColor: "#c9a96e", badge: "Bestseller" },
  { id: 14, name: "Baby Bath Robe", price: 55, color: "#e8d5c0", borderColor: "#c9a96e" },
  { id: 15, name: "Baby Towel Set", price: 65, color: "#f0e0c8", borderColor: "#c9a96e", badge: "New" },
];

export const featuredProducts = [...bathrobes.slice(0, 4), ...towels.slice(0, 4)];

export const collections = [
  {
    id: "baby",
    title: "Baby Collection",
    subtitle: "Soft. Safe. Gentle.",
    description: "Specially crafted for delicate skin",
    color: "#d4c4a8",
    link: "/collections/baby"
  },
  {
    id: "towels",
    title: "Towel Collection",
    subtitle: "Absorbent. Plush. Luxurious.",
    description: "Hotel-quality for your home",
    color: "#b8a898",
    link: "/collections/towels"
  },
  {
    id: "bathrobes",
    title: "Bathrobe Collection",
    subtitle: "Relax in Style.",
    description: "Premium comfort every morning",
    color: "#8a7a6a",
    link: "/collections/bathrobes"
  },
];
